export const base = 'https://rslang-react.herokuapp.com';
// export const base = 'http://localhost:3007';
